import { getHazardName, hazardMeta } from "./hazards";
import routes from "./routes";
import type { HubTheme, HubThemePartial, PortfolioAssetLevelOutputType } from "./types";
import { getHazardColor, getHazardIcon, hazards } from "./types";
import {
  dealiasArchetype,
  getAestheticsConfig,
  getAppName,
  getArchetypeByValue,
  getArchetypes,
  getBaseThemeName,
  getCommsConfig,
  getConfig,
  getContactSupportLink,
  getContactSupportLinkUrl,
  getCoordinateBounds,
  getCurrencyCode,
  getDefaultInputValues,
  getDocsConfig,
  getHazardList,
  getKbConfig,
  getLocaleConfig,
  getPages,
  getRiskBandsMaxLetter,
  getRiskBandsMode,
  getSettings,
  getTheme,
  getTrackingConfig,
  isTpuLabellingEnabled,
} from "./utils";

export type { HubTheme, HubThemePartial, PortfolioAssetLevelOutputType };
// This may look weird, but it's to avoid a default export.
export {
  dealiasArchetype,
  getAestheticsConfig,
  getAppName,
  getArchetypeByValue,
  getArchetypes,
  getBaseThemeName,
  getCommsConfig,
  getConfig,
  getContactSupportLink,
  getContactSupportLinkUrl,
  getCoordinateBounds,
  getCurrencyCode,
  getDefaultInputValues,
  getDocsConfig,
  getHazardColor,
  getHazardIcon,
  getHazardList,
  getHazardName,
  getKbConfig,
  getLocaleConfig,
  getPages,
  getRiskBandsMaxLetter,
  getRiskBandsMode,
  getSettings,
  getTheme,
  getTrackingConfig,
  hazardMeta,
  hazards,
  isTpuLabellingEnabled,
  routes,
};
